<!--
  ~ .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
  ~    .       .       .       .       .       .       .       .       .       .       .       .
  ~      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
  ~  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
  ~    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
  ~   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
  ~      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
  ~   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
  ~      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
  ~   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
  ~      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
  ~   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
  ~     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
  ~   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
  ~     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
  ~   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
  ~      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
  ~   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
  ~        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
  ~   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
  ~
  ~ Copyright FortyFix(c) 2024.
  ~ Title: taglie.component.html;
  ~ Path: /Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/GESFF_Gestionale_FF_Angular/src/app/Prodotti/taglie/taglie.component.html;
  ~ Description: ;
  ~ Author: giovannibattistadellaporta;
  ~ Created at: 03/04/24, 17:12;
  ~ Updated at: 03/04/24, 17:12;
  ~
  ~
  -->

<div class="card">
  <div class="card-body">
    <div class="p-3">
      <div class="row">
        <h4 class="card-title">Taglie:
          <span class="badge badge-info badge-pill px-3 font-weight-bold font-14" *ngIf="items">{{items.length}}</span>
        </h4>
        <div class="ml-auto mt-3 mt-md-0 d-flex align-items-center p-1" *ngIf="permission.isPermitted('gestione-taglie') ">
          <button class="btn btn-outline-info " style="width: 100%;"  (click)="add()"
                  type="button">Aggiungi</button>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table bg-white table-hover align-middle mb-0 HorizontalTable">
        <thead>
        <tr>
          <th scope="col">Label</th>
          <th scope="col">Fattore</th>
          <th scope="col">Azioni</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of items">
          <td>
            <span class="font-16" *ngIf="!item.modifica">{{item.taglia}}</span>
            <span *ngIf="item.modifica">
              <input [(ngModel)]="item.taglia" placeholder="titolo" type="text" class="form-control">
            </span>
          </td>
          <td>
            <span class="font-16" *ngIf="!item.modifica">{{item.fattore}}</span>
            <span *ngIf="item.modifica">
              <input [(ngModel)]="item.fattore" type="number" step="0.01" min="0.01" placeholder="Fattore"  class="form-control">
            </span>
          </td>
          <td class="align-middle" >
            <a *ngIf="!item.modifica && !editing(item)"  href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2"
               (click)='edit(item)'>
              <i-feather name="edit-3" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="item.modifica && !editing(item)" href="javascript:void(0)" ngbTooltip="Salva" class="link font-16 text-success font-medium mr-2" (click)='edit(item)'>
              <i-feather name="check" class="feather-sm"></i-feather>
            </a>
            <a href="javascript:void(0)" *ngIf="!editing(item)" class="link text-danger font-16 font-weight-bold"  (click)='delete(item)'>
              <i-feather name="trash-2" class="feather-sm"></i-feather>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
      </div>
  </div>
</div>
